import { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Checkbox, Grid, MenuItem, Typography } from "@mui/material";

import {
  TextField,
  SelectField,
  MandatoryNote,
  LoadingButton,
} from "../../../../components";
import EventCard from "../EventCard";
import { useAxios } from "../../../../hooks";

import { AiOutlineDelete } from "react-icons/ai";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CustomField from "./CustomField";
import EventBadge from "./EventBadge";
import SummaryTable from "./SummaryTable";
import { useSelector } from "react-redux";

function Form({
  formik,
  eventID,
  visitorData,
  eventObject,
  badgeOptions,
  parking,
  setParking,
  vehicleDetails,
  customFields,
}) {
  const navigate = useNavigate();
  const axiosApi = useAxios({ baseURL: "mox_api_2" });

  const { state } = useLocation();

  const [loading, setLoading] = useState(false);

  const [districtOptions, setDistrictOptions] = useState([]);
  const [vehicleCount, setVehicleCount] = useState(1);

  let totaBadgeValue =
    (formik?.values?.badge
      ? formik?.values?.badge?.reduce((sum, current, index) => {
          return (
            parseInt(current?.badge_count) *
              parseInt(current?.badge_id_amount) +
            sum
          );
        }, 0)
      : 0) +
    (formik.values.vehicle
      ? formik.values.vehicle?.reduce((sum, current, index) => {
          return (
            (parseInt(
              vehicleDetails.filter((ite, index) => {
                return ite.vehicle_type == current?.vehicle_type;
              })[0]?.amount
            ) || 0) + sum
          );
        }, 0)
      : 0);

  const handleDownloadPDF = (link) => {
    const pdfLink = link;

    window.open(pdfLink, "_blank");
  };

  const fetchDistricts = async (selectedState) => {
    try {
      const response = await axiosApi({
        url: `event/booking/districts?state_id=${selectedState}`,
        method: "GET",
      });
      if (response.status) {
        const formattedDistricts = response.data.map((district) => ({
          id: district?.district_id,
          name: district?.district_name,
        }));

        setDistrictOptions(formattedDistricts);
      }
    } catch (error) {
      console.error("Error in fetching district list", error);
    }
  };

  useEffect(() => {
    if (formik.values.state0) {
      fetchDistricts(formik.values.state0);
    }

    formik.setFieldValue(
      "visitorData[0].phone_number",
      localStorage.getItem("mobileNumber") || visitorData.phoneNumber
    );

    formik.setFieldValue("visitorData[0].gender", "");
  }, []);

  return (
    <Fragment>
      <Grid
        container
        spacing={3}
        sx={{
          textTransform: "capitalize",
        }}
      >
        {eventObject.event_name && (
          <Grid item xs={12} sm={12}>
            <EventCard
              eventObject={eventObject}
              handleDownloadPDF={handleDownloadPDF}
            />
          </Grid>
        )}

        <Grid
          item
          container
          spacing={3}
          m={"10px 0px"}
          sx={{
            // boxShadow: "rgb(232, 196, 144) 3px 3px 5px -2px",
            padding: "10px 10px 10px 0px !important",
            borderRadius: "12.5px",
            border: "1px solid rgb(232, 222, 207)",
          }}
        >
          <Grid item xs={6}>
            <TextField
              name="visitorData[0].name"
              placeholder={"Name"}
              formikProps={formik}
              disabled={visitorData.firstName}
            />
          </Grid>

          <SelectField
            label="Select Your Gender"
            placeHolder="Select Your Gender"
            name="visitorData[0].gender"
            value={formik.values.visitorData[0]?.gender}
            options={[
              { id: "Male", name: "Male" },
              { id: "Female", name: "Female" },
            ]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.district && formik.errors.district}
            required
            disabled={formik.values.paymentStatue === "Pending"}
          />

          <Grid mt={1} item xs={12}>
            <TextField
              name="visitorData[0].phone_number"
              label={"Mobile No"}
              formikProps={formik}
              disabled
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              // label="Enter Your Email"
              placeholder="Enter Your Email"
              name="visitorData[0].email_id"
              required
              formikProps={formik}
              disabled={
                Boolean(state?.first_name) ||
                formik.values.paymentStatue === "Pending"
              }
            />
          </Grid>

          {badgeOptions.length > 0 && (
            <EventBadge
              index={0}
              eventID={eventID}
              eventObject={eventObject}
              formikProps={formik}
              badgeOptions={badgeOptions}
            />
          )}

          <Grid item xs={12}>
            <CustomField
              formikProps={formik}
              customFields={customFields}
              visitorDataIndex={0}
            />
          </Grid>
        </Grid>

        {eventObject.is_parking && Boolean(vehicleDetails.length) && (
          <Typography variant="body1" sx={{ fontWeight: "700" }}>
            <Checkbox
              checked={parking}
              style={{ alignSelf: "baseline" }}
              onClick={() => {
                setParking(!parking);
                formik.setFieldValue("vehicle", []);
              }}
            />
            Select this option to reserve a parking slot for the event by
            providing your vehicle details
          </Typography>
        )}

        <Grid item container>
          {parking && Boolean(vehicleDetails.length) && (
            <Fragment>
              {Array(vehicleCount)
                .fill(true)
                .map((item, index) => {
                  return (
                    <Grid
                      item
                      container
                      spacing={3}
                      m={"2px 0px"}
                      sx={{
                        // boxShadow: "rgb(232, 196, 144) 3px 3px 5px -2px",
                        padding: "10px 10px 10px 0px !important",
                        borderRadius: "12.5px",

                        border: "1px solid rgb(232, 222, 207)",
                        position: "relative",
                      }}
                    >
                      <Grid item xs={6}>
                        <TextField
                          select
                          formikProps={formik}
                          placeholder="Choose Vehicle Type"
                          name={`vehicle[${index}].vehicle_type`}
                          value={
                            formik.values[`vehicle[${index}].vehicle_type`]
                          }
                        >
                          {vehicleDetails.map((item) => {
                            return (
                              <MenuItem
                                value={item.vehicle_type}
                                disabled={
                                  formik.values.vehicle.filter((ite) => {
                                    return (
                                      ite.vehicle_type == item.vehicle_type
                                    );
                                  }).length
                                }
                              >
                                {`${item.vehicle_type}  - INR ${item.amount}`}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </Grid>

                      <Grid item xs={4}>
                        <TextField
                          name={`vehicle[${index}].vehicle_number`}
                          placeholder={"Vehicle No"}
                          formikProps={formik}
                        />
                      </Grid>

                      <Grid item xs={2} alignContent={"center"}>
                        {index == 0 ? (
                          <Fragment>
                            {vehicleDetails.length >
                              Array(vehicleCount).length && (
                              <AddCircleIcon
                                onClick={() => {
                                  formik.setFieldValue(
                                    "vehicleCount",
                                    vehicleCount + 1
                                  );
                                  setVehicleCount((prev) => prev + 1);
                                }}
                              />
                            )}
                          </Fragment>
                        ) : (
                          <AiOutlineDelete
                            style={{
                              color: "white",
                              padding: "3px",
                              fontSize: "27.5px",
                              backgroundColor: "#ff9191",
                              backgroundImage:
                                "linear-gradient(164deg, #ff9191 0%, #FF2525 74%)",
                              borderRadius: "5px",

                              boxShadow: "1px 2px 4px 1px #bbbaba",
                            }}
                            onClick={() => {
                              formik.setFieldValue(
                                "vehicleCount",
                                vehicleCount - 1
                              );
                              let newVehicleValue = [...formik.values.vehicle];
                              newVehicleValue.pop();
                              formik.setFieldValue("vehicle", newVehicleValue);

                              setVehicleCount((prev) => prev - 1);
                            }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  );
                })}
            </Fragment>
          )}
        </Grid>

        {Boolean(
          formik.values?.eventAmount || formik.values?.badge[0]?.badge_id_amount
        ) && (
          <SummaryTable
            formikProps={formik}
            eventObject={eventObject}
            vehicleDetails={vehicleDetails}
            badgeOptions={badgeOptions}
          />
        )}
      </Grid>

      <MandatoryNote />

      <Grid item container spacing={{ sl: 2 }}>
        <Grid item xs={12} sl={6}>
          <LoadingButton
            loading={loading}
            onClick={formik.handleSubmit}
            disabled={!formik.dirty || !formik.isValid}
            fullWidth
            style={{ fontWeight: 800, marginTop: "10px" }}
          >
            {`${
              !formik.values.eventAmount ? "Take Next Step" : "Proceed to Pay"
            }`}

            {Boolean(formik.values.eventAmount) &&
              `: INR ${parseInt(formik.values.eventAmount) + totaBadgeValue}`}
          </LoadingButton>
        </Grid>

        <Grid item xs={12} sl={6}>
          <LoadingButton
            loading={loading}
            onClick={() => navigate(-1)}
            fullWidth
            backgroundColor="rgba(245, 240, 229, 0)"
            style={{ fontWeight: 800, color: "black" }}
          >
            Back{" "}
          </LoadingButton>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Form;
